import { ca } from '@cian/analytics';

export const trackShowOnboardingModal = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'MyHomeMakeMoney',
    action: 'show',
    label: 'OnbPopup',
  });
};

export const trackCloseOnboardingModal = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'MyHomeMakeMoney',
    action: 'clickClose',
    label: 'OnbPopup',
  });
};

export const trackClickOnboardingButton = (slide: number) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'MyHomeMakeMoney',
    action: 'clickNext',
    label: 'OnbPopup',
    page: {
      extra: {
        slide,
      },
    },
  });
};

export const trackClickOnboardingBackButton = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'MyHomeMakeMoney',
    action: 'clickBack',
    label: 'OnbPopup',
  });
};
